const PropTypes = require('prop-types');

module.exports = PropTypes.shape({
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	title: PropTypes.string.isRequired,
	isFavorite: PropTypes.bool
});
